module.exports = __webpack_public_path__ + "img/emoji_20.c920501d.png";